import { useCallback, useEffect, useState } from "react";
import supportApi from "support/api/supportApi";

export default function useConversation(reference) {
  const [conversation, setConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [csat, setCsat] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!reference) {
      return;
    }
    setLoading(true);
    setError(null);
    const response = await supportApi.getConversation(reference);
    setLoading(false);
    if (response.status !== 200 || !response.data) {
      setError(response.status);
      return;
    }
    setConversation(response.data.conversation || null);
    setMessages(Array.isArray(response.data.messages) ? response.data.messages : []);
    setCsat(response.data.csat || null);
  }, [reference]);

  useEffect(() => {
    setConversation(null);
    setMessages([]);
    setCsat(null);
    load();
  }, [reference, load]);

  return { conversation, messages, csat, loading, error, reload: load };
}
